module.exports = __webpack_public_path__ + "static/media/duckhunt_0.a48c2618.png";